


















































































































import { dateFilter } from "@/utils/date-util";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { colorClassByStatus } from "@/utils/page-utils";
import { InputWings } from "wings-ui-components";
import CallEventsDetail from "@/components/Call/Statistic/CallEventsDetail.vue";

@Component({
  components: {CallEventsDetail, InputWings},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class CallDetailIncomingInfo extends Vue {

  @Action("getCallStatisticDetailIncomingInfo") actionGetItem: any;

  private messageInfo: object = {
    id: '',
    create_date: '',
    start_date: '',
    end_date: '',
    duration: '',
    module: '',
    originator: '',
    operator: '',
    country: '',
    recipient: '',
    partner: '',
    status: '',
    content: '',
  };

  async created() {
    if (this.$route.params.id) {
      this.messageInfo = await this.actionGetItem(this.$route.params.id);
    }
  }

  back(): void {
    this.$router.push('/call/detail_incoming/');
  }
}
